<img (load)="imageLoaded()" [attr.alt]="message.data.altText" [attr.src]="message.data.imageUrl"
     class="pa-image pa-message-content">
